export const documentProps = {
  title: 'Client Intake Automation — From First Contact to Paid Invoice',
  description:
    'Automate your entire client intake chain: scheduling, follow-ups, CRM updates, invoice generation, and document collection. Starting at $3,000. Free discovery call available.',
};
